import { useEffect } from 'react'
import OKModal from 'components/commons/OKModal/OKModal'

import { i18n } from "core/i18n"

import { taggingOpenedTooltip } from '../../helpers/bringAccountTagging'

import { TOOLTIP_TEXT_MODAL } from "../../constants/bringAccountConstants"

import './modalTooltip.scss'

const { FormattedText } = i18n

export const ModalTransferTooltip = ({ type, onAccept, onClose }) => {
    useEffect(() => {
        taggingOpenedTooltip()
    }, [])

    const buildModalContent = () => {
        const { title, descriptionPartOne, descriptionPartTwo, descriptionPartThree } = TOOLTIP_TEXT_MODAL[type]

        return (
            <div className="container-fluid">
                <div className="row">
                <div className="col-xs-12">
                    <h4 className="transfer-account__modal-tooltip__title">
                        <FormattedText value={title} />
                    </h4>
                </div>
                </div>
                <div className="row">
                <div className="col-xs-12 transfer-account__modal-tooltip__description">
                    <p>
                        <FormattedText value={descriptionPartOne} />
                    </p>
                    <p>
                        <FormattedText value={descriptionPartTwo} />
                    </p>
                    {
                        descriptionPartThree && (
                            <p>
                                <FormattedText value={descriptionPartThree} />
                            </p>
                        )
                    }
                </div>
                </div>
            </div>
        );
    }

    return (
        <OKModal
            isOpen={!!type}
            size="large"
            content={buildModalContent()}
            footerType="navigation"
            primaryButtonText="transfer_account-transfer_account_from_another_bank_step3_tooltip1_button"
            secondaryButtonText="common-cancel"
            onPrimaryButtonClick={onAccept}
            onSecondaryButtonClick={onClose}
            onCloseCallback={() => onClose(true)}
        />
    )
}